module.exports = __webpack_public_path__ + "img/illu_hod.fd31818e.svg";